export const AttributeModel = {
    attributeId: '',
    name: '',
    mnemonic: '',
    type: 0,
    deleted: false
}

export const AttributeClientModel = {
    attributeId: '',
    clientId: ""
}

export const AttributeHeadersModel = [
    {
        text: "Действия",
        value: "actions",
        sortable: false
    },
    {
        text: "Название",
        value: "name"
    },
    {
        text: "Мнемоника",
        value: "mnemonic"
    },
    {
        text: "Тип переменной",
        value: "typeHuman"
    },
    {
        text: "Удалён",
        value: "deletedHuman"
    },
]

export const AttributeTypesModel = [
    {
        text: "Строка",
        value: 0
    },
    {
        text: "Число",
        value: 1
    },
    {
        text: "Логический",
        value: 2
    },
    // {
    //     text: "Денежный",
    //     value: 3
    // },
    // {
    //     text: "Дата",
    //     value: 4
    // },
    {
        text: "Список",
        value: 5
    }
]
